/**
 * Route definitions. Entry point to all routes.
 */

/**
 * Dependencies
 */
import React from 'react';
import { Route } from 'react-router';
import appConfig from '@nerdwallet/app-config';

/**
 * Local Dependencies
 */
import Container from './container';
import dataDependencies from './data-dependencies';

const baseUri = appConfig.BASE_URI;

const routes = (
  <Route
    dataDependencies={dataDependencies}
    path={baseUri}
    render={({ match, location, history }) => (
      <Container match={match} location={location} history={history} />
    )}
  />
);

export default routes;
